export type ExportPdfToolState = Readonly<ExportPdfInactiveState | ExportPdfActiveState>;

type ExportPdfInactiveState = {
  isActive: false;
  params: null;
};

type ExportPdfActiveState = {
  isActive: true;
  params: ExportPdfLocationParams | ExportPdfPolygonParams;
};

export enum ExportPdfActiveType {
  Location = 'Location',
  Polygon = 'Polygon',
}

export type ExportPdfLocationParams = {
  type: ExportPdfActiveType.Location;
  data: {
    title: string;
  };
};

export type ExportPdfPolygonParams = {
  type: ExportPdfActiveType.Polygon;
};
